import { createContext } from "react";

const AssetManagementContent = createContext({
  selectAsset: asset => {}
});

export default AssetManagementContent
